var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { StyleSheet } from 'aphrodite/no-important';
import renderObjectOfComponents from '../../utilities/components/renderObjectOfComponents';
import { mediaBreakpointDown, sizes } from 'conversional-theme';
import BaseComponent from '../base/BaseComponent';
/**
 * FlexboxComponent
 * Purpose      Organize child components in row or column order
 * Responsive   None
 * Nestable     True
 * Base         False
 */
var Flexbox = /** @class */ (function (_super) {
    __extends(Flexbox, _super);
    function Flexbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Flexbox.prototype.render = function () {
        var _a = this.props, spots = _a.spots, flexDirection = _a.flexDirection, styles = _a.styles, componentKey = _a.componentKey, preventBubbling = _a.preventBubbling;
        var onClickHandler = function (e) {
            if (preventBubbling) {
                e.stopPropagation();
                return;
            }
        };
        return (_jsx(BaseComponent, { onClick: onClickHandler, componentKey: componentKey, injectedStyles: styles, styles: [Style({ flexDirection: flexDirection }).flexBox], children: renderObjectOfComponents(spots) }));
    };
    Flexbox.defaultProps = {
        flexDirection: 'row',
    };
    return Flexbox;
}(React.PureComponent));
var Style = function (props) {
    var _a;
    return StyleSheet.create({
        flexBox: __assign(__assign({ display: 'flex', textAlign: 'left', backgroundPosition: 'center center', backgroundSize: 'cover' }, props), (_a = {}, _a[mediaBreakpointDown(sizes.sm)] = {
            flexWrap: 'wrap',
        }, _a)),
    });
};
export default Flexbox;
